// extracted by mini-css-extract-plugin
export var fiveImagesLayout = "style-module--fiveImagesLayout--ae023";
export var sixImagesLayout = "style-module--sixImagesLayout--7901c";
export var twoImagesLayout = "style-module--twoImagesLayout--50b9a";